import { HttpParams } from '@angular/common/http';
import { ApiRequest } from './';

export class CategoryStreamsRequestModel implements ApiRequest {
    constructor(public categoryId: string,
                public includeSubcategories: boolean,
                public published: boolean,
                public page: number,
                public rows: number,
                public createdAfterDateTime?: string){}

    asURLSearchParams(): HttpParams {
        let params = new HttpParams()
        .set('categoryId', String(this.categoryId))
        .set('includeSubcatgories', String(this.includeSubcategories))
        .set('published', String(this.published))
        .set('page', String(this.page))
        .set('rows', String(this.rows));
        return this.createdAfterDateTime ? params.set('createdAfterDateTime', this.createdAfterDateTime) : params;
    }
}
